import getApiActionTypesHandlers from '../../../shared/store/getApiActionTypesHandlers';
import reducerFactory from '../../../shared/store/reducerFactory';

import { fetchJobQueueStatusReportsTypes, terminateStuckCalcJobTypes } from './types';

export const initialState = {
  jobQueueStatusReports: [],
  isFetchingJobQueueStatusReports: false,
  isTerminatedStuckCalcJob: false,
};

const jobQueueStatusReportsReducer = reducerFactory({
  initialState,
  actionHandlers: {
    ...getApiActionTypesHandlers({
      apiTypes: fetchJobQueueStatusReportsTypes,
      payloadKey: 'jobQueueStatusReports',
      fetchingKey: 'isFetchingJobQueueStatusReports',
    }),

    ...getApiActionTypesHandlers({
      apiTypes: terminateStuckCalcJobTypes,
      fetchingKey: 'isTerminatedStuckCalcJob',
    }),
  },
});

export default jobQueueStatusReportsReducer;
